const Flickity = require('flickity');

const PopupApp = (dom) => {

    const aBtns = dom.querySelectorAll('[data-listen]');
    const closeBtns = dom.querySelectorAll('[data-vl-close]');
    const nextButton = dom.querySelector('[data-nextstory]');
    const aLink = aBtns ? aBtns[0].getAttribute('data-listen') : null;
    let audio = null;

    dom.addEventListener('vl:open', () => {
        dom.classList.add('active');
    });

    dom.addEventListener('vl:close', () => {
        if (audio) {
            audio.pause();
        }
        dom.classList.remove('active');
    });

    dom.addEventListener('vl:video', () => {
        const vBtn = dom.querySelector('[data-media]');
        if (vBtn) {
            vBtn.click();
        }
    });

    dom.addEventListener('vl:audio', () => {
       if (audio) {
           audio.pause();
       }
       if (aLink) {
           audio = new Audio(aLink);
           audio.play();
       }
    });

    for (const aBtn of aBtns) {
        aBtn.addEventListener('click', (event) => {
            event.preventDefault();
            const e = new CustomEvent('vl:audio');
            dom.dispatchEvent(e);
        });
    }

    for (const close of closeBtns) {
        close.addEventListener('click', (event) => {
            event.preventDefault();
            const e = new CustomEvent('vl:close');
            dom.dispatchEvent(e);
        });
    }

    if (nextButton) {
        nextButton.addEventListener('click', (event) => {
            event.preventDefault();

            const e = new CustomEvent('vl:close');
            dom.dispatchEvent(e);

            const ce = new CustomEvent('vl:open');
            const nId = nextButton.getAttribute('data-nextstory');
            document.querySelector(`[data-vl-id="${nId}"]`).dispatchEvent(ce);

        });
    }


}


export default () => {

    const videoHolder = document.querySelector('[data-vl-videos]');
    const popups = document.querySelectorAll('[data-vl-id]');

    const init = () => {
        const parent = videoHolder.parentElement;
        const prevs = parent.querySelectorAll('[data-prev]');
        const nexts = parent.querySelectorAll('[data-next]');
        const videoButtons = parent.querySelectorAll('[data-vl-video-trigger]');
        const audioButtons = parent.querySelectorAll('[data-vl-audio-trigger]');
        const readButtons = parent.querySelectorAll('[data-vl-open-trigger]');
        const nofSlides = videoHolder.children.length;



        const handleChange = (index) => {

            if (index === 0) {
                for(const prev of prevs) {
                    prev.classList.add('disable');
                }
            } else if (index === nofSlides - 2) {
                for(const prev of prevs) {
                    prev.classList.remove('disable');
                }
                // for(const next of nexts) {
                //     next.classList.add('disable');
                // }
            } else {
                for(const prev of prevs) {
                    prev.classList.remove('disable');
                }
                for(const next of nexts) {
                    next.classList.remove('disable');
                }
            }
        }


        const flickity = new Flickity(videoHolder, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            // autoPlay: 5000
            on: {
                ready: () => {
                    handleChange(0);
                },
                change: (index) => {
                    handleChange(index);
                }
            }
        });


        for(const next of nexts) {
            next.addEventListener('click', (e) => {
                e.preventDefault();
                flickity.next();
            });
        }
        for(const prev of prevs) {
            prev.addEventListener('click', (e) => {
                e.preventDefault();
                flickity.previous();
            });
        }

        for(const vbtn of videoButtons) {
            vbtn.addEventListener('click', (e) => {
                e.preventDefault();
                const id = vbtn.getAttribute('data-vl-video-trigger');
                const ce = new CustomEvent('vl:open');
                const ve = new CustomEvent('vl:video');
                document.querySelector(`[data-vl-id="${id}"]`).dispatchEvent(ce);
                document.querySelector(`[data-vl-id="${id}"]`).dispatchEvent(ve);
            });
        }

        for(const abtn of audioButtons) {
            abtn.addEventListener('click', (e) => {
                e.preventDefault();
                const id = abtn.getAttribute('data-vl-audio-trigger');
                const ce = new CustomEvent('vl:open');
                const ae = new CustomEvent('vl:audio');
                document.querySelector(`[data-vl-id="${id}"]`).dispatchEvent(ce);
                document.querySelector(`[data-vl-id="${id}"]`).dispatchEvent(ae);
            });
        }

        for(const rbtn of readButtons) {
            rbtn.addEventListener('click', (e) => {
                e.preventDefault();
                const id = rbtn.getAttribute('data-vl-open-trigger');
                const ce = new CustomEvent('vl:open');
                document.querySelector(`[data-vl-id="${id}"]`).dispatchEvent(ce);
            });
        }


        for (const popup of popups) {

            PopupApp(popup);

        }

    }

    if (videoHolder) {
        init();
    }

}
